import React from 'react'

function Error() {
    return (
        <section>
            <h1>Ooops dead end!!!</h1>
        </section>
    )
}

export default Error
